import MateriasPeligrosasADRClass from "src/app/model/api/datos/materiasPeligrosasADRClass";
import ValoracionesClass from "src/app/model/api/datos/valoracionesClass";
import ValoresClass from "src/app/model/api/datos/valoresClass";
import ApiService from "src/app/model/api/generic/apiService";
import MotivoAccesoClass from "src/app/model/api/otp/motivoAcceso";

export default class DatosService extends ApiService {

    public async getValores(): Promise<ValoresClass[]> {
        return await this.service.HttpGet('/api/datos/getvalores')
    }

    public async getProgramacion(areaId: number): Promise<string> {
        return await this.service.HttpGet('/api/datos/getprogramacion', {
            AreaId: areaId
        })
    }

    public async getViewProgramacion(areaId: number): Promise<string> {
        return await this.service.HttpGet('/api/datos/getviewprogramacion', {
            AreaId: areaId
        })
    }

    public async getValoraciones(): Promise<ValoracionesClass[]> {
        return await this.service.HttpGet('/api/datos/getvaloraciones')
    }

    public async getValoresView(): Promise<ValoresClass[]> {
        return await this.service.HttpGet('/api/datos/getvaloresview')
    }

    public async getMotivosOTP(): Promise<MotivoAccesoClass[]> {
        return await this.service.HttpGet('/api/datos/getmotivosotp')
    }

    public async getFechaAvisoCopiasSeguridad(): Promise<Date> {
        return await this.service.HttpGet('/api/datos/getfechaavisocopiasseguridad')
    }

    public async getMateriasPeligrosasAdr(): Promise<MateriasPeligrosasADRClass[]> {
        return await this.service.HttpGet('/api/datos/getmateriaspeligrosasadr')
    }

}